<template>
  <div>
    <table class="dep-table details-table" style="width: 100%; border-collapse: collapse; font-size: 13px;">
      <thead>
        <tr style="background-color: #d3d3d3;">
          <th style="border: 1px solid #000; padding: 2px; text-align: center; width: 50px;">S/L</th>
          <th style="border: 1px solid #000; padding: 2px; text-align: left;">Code</th>
          <th style="border: 1px solid #000; padding: 2px; text-align: left;">Item</th>
          <th style="border: 1px solid #000; padding: 2px; text-align: center;">Qty (Kg)</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(detail, index) in sampleDelivery?.sample_delivery_details || []" :key="detail.id || index">
          <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ index + 1 }}</td>
          <td style="border: 1px solid #000; padding: 2px; text-align: left;">{{ detail.product?.code || '-' }}</td>
          <td style="border: 1px solid #000; padding: 2px; text-align: left;">{{ detail.product?.name || '-' }}</td>
          <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ detail.qty ?? 0 }}</td>
        </tr>

        <tr style="font-weight: bold; background-color: #d3d3d3;">
          <td colspan="3" style="border: 1px solid #000; padding: 2px; text-align: right;">Total</td>
          <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ totalQty }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "invSampleDeliveryDetailsTable",
  props: {
    referenceType: {
      type: String,
      default: "InvSampleDeliveryMaster",
    },
    documentId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      sampleDelivery: null,
    };
  },
  computed: {
    totalQty() {
      return (this.sampleDelivery?.sample_delivery_details || []).reduce(
        (total, detail) => total + Number(detail.qty || 0),
        0
      );
    },
  },
  mounted() {
    const id = this.documentId ?? this.$route?.query?.referenceable_id ?? this.$route?.params?.id;

    if (!id) return;

    this.$store.dispatch("getInvSampleDeliveryById", id).then((res) => {
      this.sampleDelivery = res;
    });
  },
};
</script>
